import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const MiraiGallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const [newsData, setNewsData] = useState([]); // State for storing news data
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalPages, setTotalPages] = useState(1); // Total pages from backend
  const [loading, setLoading] = useState(false); // Loading state

  const fetchNews = async (page) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://mirai-server.vercel.app/gallery-home-data?page=${page}`
      );
      const { data, pages } = response.data; // Destructure response data

      setNewsData(data); // Update news data state
      setTotalPages(pages); // Update total pages
      setLoading(false);
    } catch (error) {
      console.error("Error fetching news data:", error);
      setLoading(false);
    }
  };

  // Fetch data when the component mounts or currentPage changes
  useEffect(() => {
    fetchNews(currentPage);
  }, [currentPage]);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
      <div className="text-justify w-full max-w-screen-2xl mx-auto p-4">
        <h1 className="text-justify lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">News</h1>
        <div className="text-justify w-full grid lg:grid-cols-2 sm:grid-cols-1 gap-5 mt-10">
          {loading ? (
            <p>Loading...</p>
          ) : (
            newsData.map((item, index) => (
              <Link to={`/gallery-details/${item._id}`} key={index}>
              <div>
                <div class="w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                  
                {
                    item.singleImage ?
                    <a href="#">
                     <img class="rounded-t-lg w-full lg:h-96 sm:h-56 object-cover" src={item.singleImage} alt="" />
                   </a>
                     :
                     <div className="w-full lg:h-96 sm:h-56 bg-gray-200 rounded-t-lg">
                       
                     </div>

                  }
                 
                  <div class="p-5">
                    <a href="#">
                      <h5 class="mb-2 lg:text-2xl sm:text-xl font-bold tracking-tight font-jost text-gray-700 dark:text-white">
                        {item.title}
                      </h5>
                      <h5 class="mb-2 lg:text-lg sm:text-sm tracking-tight text-gray-600 font-jost dark:text-white">
                       Posted Date: {new Date(item.createdAt).toDateString()}
                      </h5>
                    </a>
                    
                   
                  </div>
                </div>
              </div>
              </Link>
            ))
          )}
        </div>

        {/* Pagination Controls */}
        <div className="text-justify flex justify-end mt-6">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="text-justify px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-justify px-4 py-2  font-jost text-sm bg-blue-50">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="text-justify px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiraiGallery;
